import axios from 'axios';
import { httpsCallable } from 'firebase/functions';

import EnvVars from '../services/EnvVars';
import { functions } from '../services/FirebaseService';

const local_api = EnvVars.local_api;
const dev_api = EnvVars.api;

export const ENVIRONMENT = dev_api;

export const apiClient = axios.create({
  baseURL: ENVIRONMENT,
  responseType: 'json',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    'Access-Control-Allow-Origin': '*',
  },
});

export class API {
  static sendReceiptEmail = (data: {
    orgname: string;
    email: string;
    method: string;
    amount: string;
    refNum: string;
    date: string;
    image: string;
  }) => httpsCallable(functions, 'sendEmailReceipt')(data);

  static sendNoPaymentMethodsMessage = (userId: string) =>
    httpsCallable(functions, 'sendNoPaymentMethodsError')({ userId });
}
